import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const GeneralSettings = () => {
  const [settings, setSettings] = useState({
    maxMessagesPerDay: 50,
    maxMatchDistance: 50,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const navigate = useNavigate();
  const { user, fetchWithRetry, isLoading, logout } = useAuth();

  const loadSettings = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await fetchWithRetry({
        method: "get",
        url: "/api/admin/settings",
      });
      setSettings(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Lỗi tải cài đặt:", error);
      setError(
        error.response?.data?.message ||
        (error.response?.status === 403
          ? "Bạn không có quyền truy cập trang này! Vui lòng đăng nhập lại."
          : "Không thể tải cài đặt!")
      );
      if (error.response?.status === 403 || error.response?.status === 401) {
        setTimeout(() => logout(), 3000);
      }
      setLoading(false);
    }
  }, [fetchWithRetry, logout]);

  const handleUpdateSettings = useCallback(async () => {
    try {
      const response = await fetchWithRetry({
        method: "put",
        url: "/api/admin/settings",
        data: settings,
      });
      setSuccessMessage(response.data.message);
      setTimeout(() => setSuccessMessage(null), 3000);
      await loadSettings();
    } catch (error) {
      console.error("Lỗi cập nhật cài đặt:", error);
      setError(error.response?.data?.message || "Không thể cập nhật cài đặt!");
      setTimeout(() => setError(null), 3000);
    }
  }, [settings, fetchWithRetry, loadSettings]);

  useEffect(() => {
    if (isLoading) return;

    if (!user || !user.permissions.includes("configure_settings")) {
      setError("Bạn không có quyền truy cập trang này!");
      navigate("/login");
      return;
    }
    loadSettings();
  }, [user, navigate, loadSettings, isLoading]);

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Cài đặt Chung</h2>

      {error && <p className="text-red-500 mb-4">{error}</p>}
      {successMessage && (
        <p className={`mb-4 ${successMessage.includes("thành công") ? "text-green-500" : "text-red-500"}`}>
          {successMessage}
        </p>
      )}

      {loading ? (
        <p className="text-center text-gray-500">Đang tải...</p>
      ) : (
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              Số tin nhắn tối đa mỗi ngày:
            </label>
            <input
              type="number"
              value={settings.maxMessagesPerDay}
              onChange={(e) =>
                setSettings({ ...settings, maxMessagesPerDay: parseInt(e.target.value) })
              }
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              Khoảng cách ghép đôi tối đa (km):
            </label>
            <input
              type="number"
              value={settings.maxMatchDistance}
              onChange={(e) =>
                setSettings({ ...settings, maxMatchDistance: parseInt(e.target.value) })
              }
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex justify-end">
            <button
              onClick={handleUpdateSettings}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-200"
            >
              Lưu cài đặt
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneralSettings;